import React, { useCallback, Fragment, useMemo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';
import Modal, { IGenericModalProps } from 'components/GenericModal/GenericModal';

import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';

import Documento from './Documento';
import Form from './Form';
import useStyle from './style';
import TipoDocumento from 'models/TipoDocumento';
import { assembleiasAssessorListDocumentos, assembleiasAssessorTipoDocumento } from 'store/modules/AssembleiasAssessorActions';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import { DocumentoResponse } from 'api/Assessor/documentos';

export interface EditarDocumentosModalGenericProps extends IGenericModalProps {
  key: string;
}

export interface EditarDocumentosModalProps extends IModalProps {
  genericProps: EditarDocumentosModalGenericProps;
}

export default function EditarDocumentosModal({ genericProps }: EditarDocumentosModalProps) {
  const { t } = useTranslation();
  const { tiposDocumento } = useSelector((state: IReducer) => state.assembleiasAssessor);
  const classes = useStyle();
  const dispatch = useDispatch();
  const { id } = useSelector<IReducer, IAssembleiasAssessorEvent>(
    state => state.assembleiasAssessor.evento!
  );

  const [listaDocumentos, setListaDocumentos] = useState<DocumentoResponse[]>([]);
  const listTipos = useMemo<TipoDocumento[]>(() => {
    return tiposDocumento.sort((a: TipoDocumento, b: TipoDocumento): number => {
      return a.descricao > b.descricao ? 1 : -1;
    })
  }, [tiposDocumento]);

  const buscarCategorias = useCallback(() => {
    dispatch(
      assembleiasAssessorTipoDocumento(
        () => {},
        error => {
          AxiosErrorHandler(error);
        }
      )
    );
  },[dispatch]);

  const buscarDocumentos = useCallback(() => {
    dispatch(
      assembleiasAssessorListDocumentos(
        id,
        documentos => {
          setListaDocumentos(documentos);
        },
        error => {
          AxiosErrorHandler(error);
        }
      )
    );
  },[dispatch, id]);

  useEffect(() => {
    buscarCategorias();
    buscarDocumentos();
  }, [buscarCategorias, buscarDocumentos]);

  const handleClose = useCallback(() => {
    dispatch(modalsActionsClose(genericProps.key));
  }, [dispatch, genericProps]);

  return (
    <Modal
      title={t('EditarDocumentosModal.title')}
      genericProps={{
        maxWidth: 'sm',
        onClose: handleClose,
        DialogContentProps: {
          className: classes.content,
        },
      }}
      content={
        <Fragment>
          <Form categorias={listTipos} atualizarDocumentos={buscarDocumentos} idEvento={id} />
          {
            listaDocumentos.length! ? 
              listaDocumentos.map(documento => <Documento idEvento={id} {...documento} categorias={listTipos}  key={documento.idDocumento}   atualizarDocumentos={buscarDocumentos} />)
              : (
                <div className={classes.emptyMessage}>
                  <Typography component="p">{t('EditarDocumentosModal.empty')}</Typography>
                </div>
              )
          }
        </Fragment>
      }
    />
  );
}
